export interface ISurvey {
  q1: number;
  q2: number;
  q3: number;
  q4: number;
  q5: number;
  q6: number;
  q7: number;
  q8: number;
  q9: number;
  q10: number;
  q11: number;
  comments: string;
}

export class SurveyModel {
  Survey: ISurvey;
  EndPointURL: string;
  Token: string;
}



// WEBPACK FOOTER //
// ./src/app/home/Survey.ts